import { getSiteBaseUrl } from '@/lib/siteBaseUrl'

const {
	menuListLeft,
	menuListRight,
	menuListMember,
	menuListMemberOthers,
	menuListCard,
} = window.HeaderContent

function mapMenuToNavElement(menu: {
	name: string
	link: string
	children?: {
		name: string
		link: string
	}[]
}) {
	const element: {
		'@type': string
		name: string
		url?: string
		hasPart?: {
			'@type': string
			name: string
			url?: string
		}[]
	} = {
		'@type': 'SiteNavigationElement',
		name: menu.name,
	}

	if (menu.link) {
		element.url = menu.link
	}

	if (menu.children && menu.children.length > 0) {
		element.hasPart = menu.children.map(mapMenuToNavElement)
	}

	return element
}

function buildMenuListCardJsonLd() {
	const types = ['addShipment', 'addProxyOrders']
	return types.map(type => {
		const item = menuListCard[type as 'addShipment' | 'addProxyOrders']
		return {
			'@type': 'SiteNavigationElement',
			name: item?.title || '',
			url: item.link,
		}
	})
}

export function insertSiteNavigationJsonLd() {
	const allMenus = [
		...(menuListLeft || []),
		...(menuListRight || []),
		...(menuListMember || []),
		...(menuListMemberOthers.filter(item => item.category !== 'logut') || []),
	]

	const currentLanguage = window.BUYANDSHIP.settings.current_language
	// Not really important, so we translate here only
	const nameOfJsonLd = currentLanguage.startsWith('zh')
		? '主要導航'
		: 'Main Navigation'

	const temp = {
		'@context': 'https://schema.org',
		'@type': 'SiteNavigationElement',
		name: nameOfJsonLd,
		hasPart: [
			{
				'@type': 'SiteNavigationElement',
				name: 'Home',
				url: getSiteBaseUrl(),
			},
			...allMenus.map(mapMenuToNavElement),
			...(menuListCard ? buildMenuListCardJsonLd() : []),
		],
	}

	try {
		const scriptElement = document.createElement('script')
		scriptElement.type = 'application/ld+json'
		scriptElement.innerHTML = JSON.stringify(temp)
		document.head.appendChild(scriptElement)
	} catch (error) {
		console.error('JSON-LD transform fail:', error)
	}
}
